module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "lxm-login-register__logo-text"
  }, [_vm._v("和 "), _c('span', {
    staticClass: "lxm-login-register__logo-number"
  }, [_vm._v(_vm._s(_vm.registerTeamCount))]), _vm._v(" 家公益机构一起 开启智慧公益")]), _vm._v(" "), _c('div', {
    staticClass: "lxm-login-register__content"
  }, [_c('reg-source-tip'), _vm._v(" "), _c('input-align-left', {
    attrs: {
      "type": 'text',
      "placeholder": '请输入您的机构/团队',
      "value": _vm.teamName,
      "transparent": true,
      "error": _vm.state.teamNameError
    },
    on: {
      "input": _vm.teamNameChanged,
      "click": _vm.teamNameClicked
    }
  }), _vm._v(" "), _c('input-align-left', {
    attrs: {
      "type": 'text',
      "placeholder": '请输入您的姓名',
      "value": _vm.adminName,
      "transparent": true,
      "error": _vm.state.adminNameError
    },
    on: {
      "input": _vm.adminNameChanged,
      "click": _vm.adminNameClicked
    }
  }), _vm._v(" "), _c('input-align-left', {
    attrs: {
      "type": 'email',
      "placeholder": '请输入您的邮箱',
      "value": _vm.email,
      "transparent": true,
      "error": _vm.state.emailError
    },
    on: {
      "input": _vm.emailChanged,
      "click": _vm.emailClicked
    }
  }), _vm._v(" "), _c('phone-verification', {
    attrs: {
      "smsTime": _vm.state.time.reg,
      "phone-input-name": '请输入您的手机号',
      "phone-input-labelled": false,
      "input-transparent": true
    },
    on: {
      "rqst-sms": _vm.rqstSms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-login-register__placeholder"
  }), _vm._v(" "), _c('input-align-left', {
    attrs: {
      "type": 'password',
      "placeholder": '请输入您的密码',
      "transparent": true,
      "value": _vm.regPassword,
      "error": _vm.state.regPasswordError
    },
    on: {
      "input": _vm.regPasswordChanged,
      "click": _vm.regPasswordClicked
    }
  }), _vm._v(" "), _c('input-align-left', {
    attrs: {
      "type": 'password',
      "transparent": true,
      "placeholder": '再次输入您的密码',
      "value": _vm.regPasswordConfirm,
      "error": _vm.state.regPasswordConfirmError
    },
    on: {
      "input": _vm.regPasswordConfirmChanged,
      "click": _vm.regPasswordConfirmClicked
    }
  }), _vm._v(" "), _c('register-agreement'), _vm._v(" "), _c('button-primary', {
    staticClass: "lxm-login-register__primary-button",
    attrs: {
      "text": '免费注册',
      "loading": _vm.buttonLoading,
      "disabled": _vm.buttonDisabled
    },
    on: {
      "click": _vm.clicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-login-register__btns"
  }, [_c('span', [_vm._v("我已注册过账号")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.loginClicked
    }
  }, [_vm._v("直接登录")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-login-register__logo"
  }, [_c('img', {
    attrs: {
      "src": "https://s.lingxi360.com/register/%E7%BC%96%E7%BB%84%402x.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-378d9aeb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-378d9aeb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Register.vue
// module id = 837
// module chunks = 0